import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import BasicTable from "@/components/BasicTable";
import { getTimeToString } from "@/utils/toolt";

export default function CallLog() {
  const { t } = useTranslation();
  const { id } = useParams();

  return (
    <div className="p-4">
      <BasicTable
        columns={[
          {
            title: t("Speaker"),
            dataIndex: "speaker",
            renderText: (text: string) => (
              <span className="font-semibold">{text}</span>
            ),
          },
          {
            title: t("Time"),
            dataIndex: "timestamp",
            renderText: (_: string, record: { timestamp: number[] }) => {
              const timestamp = record?.timestamp;
              const date = new Date(
                timestamp[0],
                timestamp[1] - 1,
                timestamp[2],
                timestamp[3],
                timestamp[4],
                timestamp[5],
                timestamp[6]
              );
              return getTimeToString(date.getTime());
            },
          },
          { title: t("Message"), dataIndex: "message" },
        ]}
        isDefaultToolBar={false}
        isShowCheckbox={false}
        rowKey="message"
        className="min-h-[calc(100vh-202px)] call-log-table"
        requestUrl={`/api/interior/lift/call-log/${id}`}
        isPagination={false}
        dataKey="data.body.dialogues"
      />
    </div>
  );
}
